import {Component, inject} from '@angular/core';
import {TopSalesComponent} from "../top-sales/top-sales.component";
import {EventAnalysisStoreService} from "../../../store/event-analysis-store.service";

@Component({
  selector: 'app-top-sales-card',
  templateUrl: './top-sales-card.component.html',
  imports: [
    TopSalesComponent
  ],
  styleUrls: ['./top-sales-card.component.css']
})
export class TopSalesCardComponent {
  hideMenu: boolean = true

  private readonly eventAnalysisStore = inject(EventAnalysisStoreService);

  /**
   * #534: the ranking follows the SHARED "Kombinationen einzeln" toggle, which lives in the table header next
   * to it — there is deliberately no second switch here. The card only says, quietly, that the ranking it is
   * showing is split per swap combination, so a reader who scrolled past the toggle can still tell.
   */
  isIndividualGrouping(): boolean {
    return this.eventAnalysisStore.groupingMode() === 'individual';
  }
}
